export default function contactSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "ContactPoint",
        "telephone": "+91-9448344445",
        "contactType": "customer support",
        "areaServed": "IN",
        "availableLanguage": ["English", "Kannada"]
    };
}
